module.exports = __webpack_public_path__ + "static/media/processImg2b.4ebf1464.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/processImg2b.png
// module id = 262
// module chunks = 0